import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { switchMap, take, catchError } from "rxjs/operators";
import { from, of, Observable } from "rxjs";

export const authGuard = (): Observable<boolean> => {
	const authService = inject(AuthService);
	const router = inject(Router);

	return authService.user$.pipe(
		take(1),
		switchMap((user) => {
			if (!user) {
				void router.navigate(["/login"]);
				return of(false);
			}

			// Refresh the Firebase token before allowing navigation, as admin's
			// guard does. Presence of a user object is not freshness: a session
			// whose token can no longer be refreshed would otherwise pass here
			// and fail later, at a Firestore read, as a permission error with no
			// explanation. AuthService signs the user out, says why, and sends
			// them to /login when the refresh fails.
			return from(authService.checkSessionBeforeNavigation());
		}),
		catchError((error) => {
			// Fail closed, and say where to go next.
			//
			// This guard had no catchError. Nothing returned true on error, so it
			// was never an authentication bypass — but the error escaped to the
			// router, which cancelled the navigation silently: no redirect, no
			// message. Mid-session that stranded the respondent on the previous
			// page; on a cold start or a typed URL there is no previous page, so
			// it was a blank screen.
			console.error("authGuard: failed to resolve the session", error);
			void router.navigate(["/login"]);
			return of(false);
		}),
	);
};
